module.exports = __webpack_public_path__ + "images/assets/d08215becc81b67ab5dcd4ab90f68bf4.svg";